<template>
  <div>
    <b-overlay :show="isLoading">
      <div>
        <prebecario
          v-if="prebecario && listDocuments"
          :data="prebecario"
          :list-documents="listDocuments"
          :mode="mode"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'

import PrebecariosService from '@/services/PrebecariosService'
import BecariosService from '@/services/BecariosService'
import Prebecario from './Becario.vue'

export default {
  name: 'Detalles',
  components: {
    // BCard,
    BOverlay,
    Prebecario,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    idBecario: {
      type: [Number, String],
      default: null,
    },
    curp: {
      type: String,
      default: () => {},
    },
    // MODOS:
    //  Becario = true
    //  Prebecario = false
    mode: {
      type: Boolean,
      reuired: false,
    },
  },
  data() {
    return {
      isLoading: true,
      prebecario: null,
      employee: null,
      listDocuments: null,
    }
  },
  mounted() {
    this.fetchDetailsBecario()
  },
  methods: {
    fetchDetailsPrebecario() {
      const vm = this
      PrebecariosService.getPrebecario(vm.id)
        .then(async response => {
          if (response.data && response.status && response.status === 200) {
            vm.prebecario = response.data
            await vm.fetchDocumetsPrebecarios(vm.prebecario.curp, vm.prebecario.solicitud.tipo_convocatoria.id)
          }
        })
        .finally(() => {
          vm.isLoading = false
        })
    },
    fetchDetailsBecario() {
      const vm = this
      BecariosService.getBecario(vm.id)
        .then(async response => {
          if (response.data && response.status && response.status === 200) {
            vm.prebecario = response.data.prebecario
            await vm.fetchDocumetsPrebecarios(vm.prebecario.curp, vm.prebecario.solicitud.tipo_convocatoria.id)
          }
        })
        .finally(() => {
          vm.isLoading = false
        })
    },
    fetchDataEmployee(id) {
      PrebecariosService.getDataEmployee(id)
        .then(response => {
          if (response.status === 200) {
            this.employee = response.data
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.employee = undefined
          }
        })
    },
    fetchDocumetsPrebecarios(prebecario, convocatoria) {
      const vm = this
      PrebecariosService.listDocumentsPrebcario(prebecario, convocatoria)
        .then(response => {
          vm.listDocuments = response.data
        })
    },
  },
}
</script>
